export default {
  crashCourseList: state => state.crashCourseList
}
